export const environment = {
  production: false,
  apiUrl: 'https://bipperz-dev-app.azurewebsites.net/api/v1',
  socketsUrl: 'https://bipperz-dev-app.azurewebsites.net/notification',
  blobBaseUrl: 'https://bipperzprofiles.blob.core.windows.net',
  stripePublishableKey: 'pk_test_51Taymi8LKM6VXgStcg9054hcu5RPIRtMtenKMI93swDFqOGrr8ZARCE4IlgBZaMhPWbmCHWvXGAtBIJl1FSIGojD00tyO4Pjfp',
  chatApiKey: 'htqvzyqkjxwq',
  appleClientId: 'com.bipperz.app.web',        // Apple Service ID for web (dev)
  appleNativeClientId: 'com.bipperz.app',       // Apple bundle ID for native iOS/Android
  appleRedirectUri: 'https://dev.bipperz.com/login',
};
